import { render, staticRenderFns } from "./WaitingList.vue?vue&type=template&id=685d8a2a"
import script from "./WaitingList.vue?vue&type=script&lang=js"
export * from "./WaitingList.vue?vue&type=script&lang=js"
import style0 from "./WaitingList.vue?vue&type=style&index=0&id=685d8a2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports